import type { Translation } from "./types";

const en: Translation = {
  home: {
    title: "OH MY PLAY",
    subtitle: "Scoreboard",
    loginButton: "Login",
    gymSelectionButton: "Select a Gym",
  },
  gameSelection: {
    searchButtonTitle: "Search",
    disqualifiedFailedMessage: "Disqualify Failed. Please contact the match control or tech  team.",
    disqualifiedSuccessMessage: "Disqualify Success",
    umpireSaveFailedMessage: "Umpire save failed. Please try again, and if the problem persists, please contact the match control or tech team.",
    ofTeam: "Team's",
    startGameSuccessTitle: "Start Game",
    startGameSuccessDescription: "Game started",
    startGameSuccessActionText: "OK",
    playerCallSuccessTitle: "Player Call",
    playerCallSuccessDescription: "Player called",
    playerCallSuccessActionText: "OK",
    noPlayerAlertTitle: "No Player",
    noPlayerAlertDescription: "No player data. Please check the match number and match type again, and if the error persists, please contact the administrator.",
    noPlayerAlertActionText: "OK",
    noPlayerAlertCancelText: "Cancel",
    noPlayerAlertConfirmText: "OK",
    disqualifiedSuccessTitle: "Disqualify Success",
    disqualifiedSuccessActionText: "OK",
    errorTitle: "Error",
    errorDescription: "Error occurred. Please try again, and if the problem persists, please contact the match control or tech team.",
    errorActionText: "OK",
    noMatchTitle: "No Match",
    noMatchDescription: "No match found.",
    noMatchActionText: "OK",
    noUmpireAlertTitle: "No Umpire",
    noUmpireAlertDescription: "Please select or enter the umpire.",
    noUmpireAlertActionText: "OK",
    noUmpireAlertCancelText: "Cancel",
    courtTitle: "Court.",
    court: "Court",
    match: "Match",
    loadMatchTitle: "Load a Match",
    byOrder: "Court Order",
    byTimetable: "Timetable",
    byNumber: "Enter Number",
    byMatchNumber: "Match Number",
    byOrderDescription: "You can select a match in this court.",
    byTimetableDescription: "You can select a match other courts scheduled matches.",
    byNumberDescription: "You can select a match by entering the match number.",
    byMatchNumberDescription: "View all matches sorted by match number.",
    searchMatchCheckboxTitle: "Include completed matches",
    searchMatchButtonTitle: "Search Match",
    previousMatchButtonTitle: "Previous Match",
    nextMatchButtonTitle: "Next Match",
    noMatchSearchMatchGuide: 'Click the "Search Match" button to find a match.',
    timetableSearchMatchGuide: "You can select a match other courts scheduled matches.",
    matchListTitle: "Match List",
    matchListLoading: "Loading match list...",
    matchNumberTitle: "Match Number",
    personalMatchTitle: "PERSONAL",
    teamMatchTitle: "TEAM MATCH",
    goToMatchButtonTitle: "Go to Match",
    teamMatchOrderTitle: "Team Match Order",
    checkMatchandPlayerTitle: "Check Match and Player",
    backButtonTitle: "Back",
    viewSubMatchButtonTitle: "View Sub Match",
    umpireInputDescription: "Please select or enter the umpire.",
    umpireInputPlaceholder: "Select Umpire",
    umpireInputDirection: "Type Umpire Name",
    umpire: "Umpire",
    umpireSaveButtonTitle: "Save",
    umpireErrorMessage: "Please enter the umpire. You need to enter the umpire to start the match.",
    GotoSettingButtonTitle: "Go to Position Setting",
    notReadyPlayerWalkoutButtonTitle: "Selected Player will Walkover",
    walkoverTitle: "Walkover",
    walkoverBothTeamTitle: "Both teams retired.",
    walkoverDescription: "retired on this match.",
    walkoverActionText: "Retired",
    walkoverCancelText: "Cancel",
    playerCheckDescription: "Touch the player card who has entered the court.",
    playerCallTitle: "Player Call",
    playerCallDescription: "Do you want to call the player?",
    playerCallActionText: "OK",
    playerCallCancelText: "Cancel",
    playerCallLoading: "Calling...",
    playerReadyButton: "Player(s) Ready ",
    playerCallButtonTitle: "Request to Call Player",
  },
  gamePlay: {
    gamePlayTitle: "Play Match",
    undoButtonTitle: "Undo",
    matchEndTitle: "Match End",
    gameEndTitle: "Game End",
    conductGameTitle: "Conduct Game",
    conductMatchTitle: "Conduct Match",
    walkoverTitle: "Walkover",
    matchEndDescription: "The match will be completely ended. Do you want to continue?",
    gameEndDescription: "The current game will be ended and the next game will be started. Do you want to continue?",
    matchEndButtonTitle: "Match End",
    disqualifiedTitle: "Disqualified",
    retiredTitle: "Retired",
    gameEndButtonTitle: "Game End",
    nextGameButtonTitle: "Next Game",
    errorTitle: "Error",
    errorDescription: "Error occurred. Please try again, and if the problem persists, please contact the match control or tech team.",
    errorActionText: "OK",
    positionChangeTitle: "Position Change",
    winnerTeam: "Winner",
    loserTeam: "Loser",
    positionChangeDescription: "Do you want to change the position?",
    positionChangeActionText: "Change",
  },
  gamePlayButtonGroup: {
    injuryTimeTitle: "Injury Time",
    injuryTimeResumeButtonTitle: "Resume",
    injuryTimePauseButtonTitle: "Pause",
    injuryTimeResetButtonTitle: "Reset",
    misconductDescription: "Please press the button below to record Misconduct.",
  },
  gameStart: {
    gameStartTitle: "Position Setting",
    warmUpCompleteButtonTitle: "Complete",
    warmUpBackButtonTitle: "Back",
    stopButtonTitle: "Stop",
    startButtonTitle: "Start",
    startGameButtonTitle: "Start Game as Server",
    colorSelectTitle: "Color Select",
    selectedColor: "Selected Color",
    orderTitle: "Order",
    positionTitle: "Position",
  },
  matchSettingDialog: {
    title: "Match Setting",
    numOfSetsTitle: "Number of Sets",
    pointsPerSetTitle: "Points per Set",
    numOfSetsDescription: "Set the number of sets on this match.",
    pointsPerSetDescription: "Set the points per set on this match.",
  },
  navigationBar: {
    callOperatorButtonTitle: "Get Support from Match Control",
    callOperatorSuccessTitle: "Call Success",
    callOperatorSuccessDescription: "Call success. Please wait a moment.",
    callOperatorSuccessActionText: "OK",
  },
  gymSelection: {
    gymSelectionTitle: "Gym Selection",
    selectDateTitle: "Go to pick a date",
    tournametDateTitle: "Tournament Date",
    selectGymTitle: "Go to pick a court",
  },
  courtSelection: {
    courtSelectionTitle: "Court ",
    courtSelectionInfo: "Select a court to enter the court",
    courtTitle: "Court",
    umpireButtonTitle: "Umpire",
    scoreViewButtonTitle: "Score",
    liveScoreButtonTitle: "All Court's Live Score",
    scoreboardDisplayButtonTitle: "Scoreboard Display",
  },
  navigation: {
    en: "English",
    kr: "Korean",
    es: "Spanish",
  },
  days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};

export default en;
